import React from "react";
import TopBar from "./Navbar/TopBar";
import AboutMe from "./AboutMe";
import Intro from "./Intro";
import Projects from "./Projects";
import Testimonials from "./Testimonials";
import ContactMe from "./ContactMe";
import "../styles/App.scss";

function App() {
  return (
    <div className="App">
      <TopBar />
      <div className="sections">
        <Intro />
        <AboutMe />
        <Projects />
        <Testimonials />
        <ContactMe />
      </div>
    </div>
  );
}

export default App;
